import GlobalRankingPage from 'pages/gamification/GlobalRankingPage';
import MyGamificationProfilePage from 'pages/gamification/MyGamificationProfilePage';
import GamificationRewardsPage from 'pages/admin/gamification/GamificationRewardsPage';
import DefaultLayout from 'components/layout/DefaultLayout';
import routes from 'common/routes';
import { roles } from 'common/constants/options';

const gamificationRoutes = [
  // Global Ranking - Accesible para todos los roles
  {
    key: 'global-ranking',
    exact: true,
    path: routes.globalRanking.path,
    component: GlobalRankingPage,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.trainer, roles.client, roles.supervisor],
    requiresMembership: true
  },

  // Mi Rango - Solo CLIENTE (admin/trainer no participan en el ranking)
  {
    key: 'my-gamification-profile',
    exact: true,
    path: routes.myGamificationProfile.path,
    component: MyGamificationProfilePage,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresMembership: true
  },

  // Admin: Gestión de Recompensas - Solo ADMIN
  {
    key: 'admin-gamification-rewards',
    exact: true,
    path: routes.adminGamificationRewards.path,
    component: GamificationRewardsPage,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  }
];

export default gamificationRoutes;
